import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { AppLayoutComponent } from '../core/components/app-layout/app-layout.component';
import { AuthComponent } from './pages/auth/auth.component';
import { NotFoundComponent } from './pages/shared/not-found/not-found.component';
import { AccessDeniedComponent } from './pages/shared/access-denied/access-denied.component';
import { PublicLayoutComponent } from './pages/public-layout/public-layout.component'; // Import PublicLayoutComponent

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    loadChildren: () => import('./pages/admin-panel/admin.routes').then((m) => m.adminRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: 'discover',
    component: PublicLayoutComponent, // Changed to PublicLayoutComponent
    loadChildren: () => import('./pages/discover/discover.routes').then((m) => m.discoverRoutes),
    canActivate: [], // Explicitly allow public access
  },
  {
    path: 'contact',
    component: PublicLayoutComponent,
    loadChildren: () => import('./pages/contact/contact.routes').then((m) => m.contactRoutes),
  },
  { 
    path: 'auth', 
    component: AuthComponent,
    loadChildren: () => import('./pages/auth/auth.routes').then((m) => m.routes),
  },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: '**', component: NotFoundComponent },
];  